import React from 'react';
import styles from './styles';

const BookendRow = ({left, right}) => {
  return (
    <div style={styles.tableRow}>
      <div style={styles.tableRowLeft}>
        <div>
          {typeof left === 'string' ?
            <span>{left}</span>
          : left}
        </div>
      </div>
      <div style={styles.tableRowRight}>
        <div>
          {typeof right === 'string' ?
            <span>{right}</span>
          : right}
        </div>
      </div>
    </div>
  );
}

export default BookendRow;
